import { render, staticRenderFns } from "./ForeplayAgencyBadgeLight.vue?vue&type=template&id=6aab25b2&scoped=true"
import script from "./ForeplayAgencyBadgeLight.vue?vue&type=script&lang=js"
export * from "./ForeplayAgencyBadgeLight.vue?vue&type=script&lang=js"
import style0 from "./ForeplayAgencyBadgeLight.vue?vue&type=style&index=0&id=6aab25b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab25b2",
  null
  
)

export default component.exports